// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_videoWrapper__cbC6J {
  position: relative;
  z-index: 3;
  overflow: hidden;
  padding-bottom: 56.25%;
  height: 0;
  width: 600px;
}
@media (max-width: 768px) {
  .styles_videoWrapper__cbC6J {
    width: unset;
  }
}
.styles_videoWrapper__cbC6J iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/modalVideo/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AADF;ACwBE;ED7BF;IASI,YAAA;EAAF;AACF;AAEE;EACE,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAAJ","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n\n.videoWrapper {\n  position: relative;\n  z-index: 3;\n  overflow: hidden;\n  padding-bottom: 56.25%;\n  height: 0;\n  width: 600px;\n\n  @include md {\n    width: unset;\n  }\n\n  iframe {\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoWrapper": `styles_videoWrapper__cbC6J`
};
export default ___CSS_LOADER_EXPORT___;
